const sOOnboardingLoader = async ({
  dispatch,
  request,
  injectReducer,
  getState
}) => {
  const { url } = request;
  const { searchParams } = new URL(url);
  const listingId = parseInt(searchParams.get('listingId'), 10);

  const [
    {
      default: listingOnboardingReducer,
      loadProspectiveListing,
      loadProspectiveListings,
      selectListingOnboardingProspectiveListingId,
      selectIsOnboardingSettingUp,
      selectListingOnboardingDraftListingId
    },
    { default: listingPhotosReducer, getListingUploads }
  ] = await Promise.all([
    import('../stores/listingOnboarding'),
    import('../stores/listingPhotos')
  ]);

  injectReducer(listingOnboardingReducer);
  injectReducer(listingPhotosReducer);

  const storeState = getState();

  const prospectiveListingId = selectListingOnboardingProspectiveListingId(
    storeState
  );
  const isSettingUp = selectIsOnboardingSettingUp(storeState);
  const draftListingId = selectListingOnboardingDraftListingId(storeState);

  if (!prospectiveListingId && !listingId) {
    return dispatch(loadProspectiveListings());
  }

  if (listingId && isSettingUp && !draftListingId) {
    return Promise.all([
      dispatch(loadProspectiveListing(listingId)),
      dispatch(getListingUploads({ listingId }))
    ]);
  }
  return null;
};

export default sOOnboardingLoader;
